import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { environment } from '@mri-platform/shared/core';
import { HeaderLogo, UiMainNavBarModule } from '@mri-platform/shared/ui-main-nav-bar';
import { DialogContainerDirective } from '@progress/kendo-angular-dialog';
import { MenuService } from '../../ui-services';
import { PageLoadingComponent } from '../page-loading.component';

@Component({
  selector: 'mri-shared-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
  imports: [RouterOutlet, PageLoadingComponent, UiMainNavBarModule, AsyncPipe, DialogContainerDirective],
  standalone: true
})
export class ShellComponent {
  renderWidget = !environment.integrationTest;
  @Input() headerLogo: HeaderLogo | null = null;
  constructor(
    public menu: MenuService,
    titleService: Title
  ) {
    this.headerLogo = this.headerLogo ?? { text: titleService.getTitle(), url: '' };
  }
}
